module.exports = __webpack_public_path__ + "img/161.gaming_consoles.78ffd231.svg";